var map = {
	"./lesson_5_01.pdf": 999,
	"./lesson_5_02.pdf": 1000,
	"./lesson_5_03.pdf": 1001,
	"./lesson_5_04.pdf": 1002,
	"./lesson_5_05.pdf": 1003,
	"./lesson_5_06.pdf": 1004,
	"./lesson_5_07.pdf": 1005,
	"./lesson_5_08.pdf": 1006,
	"./lesson_5_09.pdf": 1007,
	"./lesson_5_10.pdf": 1008,
	"./lesson_5_11.pdf": 1009,
	"./lesson_5_12.pdf": 1010,
	"./lesson_5_13.pdf": 1011,
	"./lesson_5_14.pdf": 1012
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 998;